import { mapGetters } from 'vuex';
import mvtLocalHighlightTempDetail  from '@/common/components/mvtlocalhighlighttempdetail/mvt-localhighlighttempdetail.vue'
//todo cw-4102 getCriteria & getCanonicalUrl
export default {
    name: 'mvtLocalHighlight',
    props: {
        localHighlight: {
            type: Array,
            default: null
        },
        max: {
           type: Number,
           default : 6
        }
    },
    components: {
        mvtLocalHighlightTempDetail
    },
    methods: {
        toggle(){
            this.showMore = !this.showMore;
        },
        toggleMonthlyAvg() {
           this.showChart = !this.showChart;
           if(!this.showChart) {
            this.$refs.localHighlights.scrollIntoView({behavior: 'smooth'})
           }
        },
    },
    computed:{
        ...mapGetters('glb', ['glb']),
        needShowMore(){
            return !this.showMore && this.dataArray.length > this.max;
        },
        dataArray(){
            var array = [];
            if(this.localHighlight && this.localHighlight.length > 0){
                for(var i = 0; i < this.localHighlight.length; i++){
                    var section = this.localHighlight[i].list;
                    if(section && section.length){
                        for(var j = 0; j < section.length; j++){
                            var item = section[j];
                            array.push({
                                image: item.image,
                                title: item.title,
                                value: item.value,
                                description: item.description || '',
                                monthlyAverage: item.monthlyAverage || null
                            });
                        }
                    }
                }
            }
            return array;
        },
        getData(){
            if(this.needShowMore){
                return this.dataArray.slice(0, this.max);
            }
            return this.dataArray;
        }
    },
    data(){
        return {
            showMore: false,
            showChart: false,
        }
    },

};
